import React, { useState } from 'react';
import { StarIcon, TruckIcon } from 'lucide-react';
import { SubscriptionCard } from './SubscriptionCard';
export function ProductDetails() {
  const [purchaseType, setPurchaseType] = useState<'subscription' | 'onetime'>('subscription');
  const [frequency, setFrequency] = useState('4weeks');
  return <div className="w-full space-y-6" data-id="element-314">
      {/* Product Title */}
      <div data-id="element-315">
        <h1 className="font-serif text-3xl lg:text-5xl font-bold text-[#2d4a3a] mb-3" data-id="element-316">
          2:11 Frankincense
        </h1>
        <div className="inline-block border-2 border-[#496f58] text-[#496f58] text-xs font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-317">
          Biblical Botanicals for the Restricted Body
        </div>

        {/* Reviews */}
        <div className="flex flex-wrap items-center gap-2 mb-4" data-id="element-318">
          <div className="flex items-center gap-1" data-id="element-319">
            <span className="font-bold text-gray-900 text-sm" data-id="element-320">Excellent</span>
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#00b67a] text-[#00b67a]" data-id="element-321" />)}
          </div>
          <div className="text-xs text-gray-600" data-id="element-322">
            <span className="font-semibold" data-id="element-323">Trustpilot</span>
          </div>
        </div>

        {/* Description */}
        <p className="text-gray-700 leading-relaxed text-sm lg:text-base" data-id="element-324">
          Restore your God-given mobility. This clinically-studied frankincense
          formula supports your joint comfort and daily ease so you can move
          freely, care for your family, and live out the responsibilities God
          has placed on your life.{' '}
        </p>
      </div>

      {/* Subscription Card */}
      <div className="space-y-3" data-id="element-325">
        <SubscriptionCard selected={purchaseType === 'subscription'} onSelect={() => setPurchaseType('subscription')} title="Subscribe & Save" discountPercent="40%" benefits={['Feel more comfortable within 2 weeks', '40% off your first month', '15% off every month after', 'Free shipping, Forever', 'Pause or cancel anytime']} data-id="element-326" />

        {purchaseType === 'subscription' && <div className="flex items-center justify-between px-5 py-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-327">
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-328">
              Delivery Every 30 Days
            </div>
          </div>}

        <SubscriptionCard selected={purchaseType === 'onetime'} onSelect={() => setPurchaseType('onetime')} title="Try Today & Save" discountPercent="20%" benefits={[]} data-id="element-329" />
      </div>

      {/* Add to Cart Button */}
      <button className="w-full bg-[#496f58] hover:bg-[#3d5a47] text-white font-bold text-base lg:text-lg py-4 lg:py-5 rounded-xl transition-all shadow-lg hover:shadow-xl" data-id="element-330">
        Start Now
      </button>

      {/* Shipping & Referral */}
      <div className="flex flex-col items-center gap-2 text-sm pt-2" data-id="element-331">
        <div className="flex items-center gap-2 text-gray-600" data-id="element-332">
          <TruckIcon className="w-4 h-4 text-[#496f58]" data-id="element-333" />
          <span className="font-medium text-xs lg:text-sm" data-id="element-334">
            Free Shipping on orders £30+
          </span>
        </div>
        <button className="text-[#496f58] font-semibold hover:underline text-xs lg:text-sm" data-id="element-335">
          Referred by a friend?
        </button>
      </div>

      {/* Trust Logos - Mobile Only */}
      <div className="lg:hidden grid grid-cols-2 gap-6 pt-6 mt-6 border-t border-gray-200" data-id="element-336">
        {/* BBC Dragons' Den */}
        <div className="text-left" data-id="element-337">
          <div className="font-bold text-xs mb-1" data-id="element-338">BBC</div>
          <div className="font-serif text-base font-bold text-gray-900 mb-1" data-id="element-339">
            DRAGONS' DEN
          </div>
          <p className="text-[10px] text-gray-600 italic leading-tight" data-id="element-340">
            "The biblical botanical Christian women are using to restore their
            daily mobility"
          </p>
          <p className="text-[9px] text-gray-400 mt-0.5" data-id="element-341">Sara Davies, Host</p>
        </div>

        {/* Forbes */}
        <div className="text-left" data-id="element-342">
          <div className="font-serif text-xl font-bold text-gray-900 mb-1" data-id="element-343">
            Forbes
          </div>
          <p className="text-[10px] text-gray-600 leading-tight" data-id="element-344">
            "The Most Potent & Effective Frankincense Supplement for Joint
            Comfort yet.."
          </p>
        </div>
      </div>
    </div>;
}